/**
 * PupStyle Size Guide Component
 * Handles tab switching and breed selection functionality
 */

(function() {
  'use strict';

  // Initialize all size guides on the page
  function initSizeGuides() {
    const sizeGuides = document.querySelectorAll('.pup-size-guide');
    sizeGuides.forEach(initSizeGuide);
  }

  function initSizeGuide(container) {
    if (!container) return;
    
    const tabs = container.querySelectorAll('.pup-size-guide__tab');
    const contents = container.querySelectorAll('.pup-size-guide__content');
    const breedSelect = container.querySelector('.pup-size-guide__breed-dropdown');
    const breedResults = container.querySelector('.pup-size-guide__breed-results');
    const noSelectionMessage = container.querySelector('.pup-size-guide__no-selection');

    // Tab switching
    tabs.forEach(tab => {
      tab.addEventListener('click', function(e) {
        e.preventDefault();
        
        const targetId = this.getAttribute('data-tab');
        
        // Remove active class from all tabs and contents
        tabs.forEach(t => t.classList.remove('active'));
        contents.forEach(c => c.classList.remove('active'));
        
        // Add active class to clicked tab and corresponding content
        this.classList.add('active');
        const targetContent = container.querySelector('[data-content="' + targetId + '"]');
        if (targetContent) {
          targetContent.classList.add('active');
        }
      });
    });

    // Breed selector
    if (breedSelect && breedResults) {
      // Get all breed info containers within the results area
      const breedInfoContainers = breedResults.querySelectorAll('.pup-size-guide__breed-info');
      
      // Hide all breed info on initial load
      breedInfoContainers.forEach(function(info) {
        info.style.display = 'none';
      });
      
      breedSelect.addEventListener('change', function() {
        var selectedBreed = this.value;
        
        // Hide all breed info containers
        breedInfoContainers.forEach(function(info) {
          info.classList.remove('active');
          info.style.display = 'none';
        });
        
        // Show selected breed info or no-selection message
        if (selectedBreed) {
          // Find the breed info by data-breed attribute
          var selectedInfo = breedResults.querySelector('[data-breed="' + selectedBreed + '"]');
          if (selectedInfo) {
            selectedInfo.classList.add('active');
            selectedInfo.style.display = 'block';
          }
          // Hide the no-selection message
          if (noSelectionMessage) {
            noSelectionMessage.style.display = 'none';
          }
        } else {
          // Show the no-selection message when nothing is selected
          if (noSelectionMessage) {
            noSelectionMessage.style.display = 'block';
          }
        }
      });

      // Trigger change on load if there's a default value
      if (breedSelect.value) {
        breedSelect.dispatchEvent(new Event('change'));
      }
    }
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeGuides);
  } else {
    initSizeGuides();
  }

  // Also try to init after a short delay for dynamically loaded content
  setTimeout(initSizeGuides, 500);

  // Re-initialize when Shopify section is loaded/updated (for theme editor)
  document.addEventListener('shopify:section:load', function(event) {
    var container = event.target.querySelector('.pup-size-guide');
    if (container) {
      initSizeGuide(container);
    }
  });

  // Expose globally for manual initialization
  window.PupSizeGuide = {
    init: initSizeGuides,
    initSingle: initSizeGuide
  };

})();
